import SenderModel from "../models/SenderModel";
import InstitutionModel from "../models/InstitutionModel";
import PersonModel from "../models/personModel";
import InstitutionService from "./InstitutionService";
import PersonService from "./PersonService";
import PersonToInstitutionRelationService from "./PersonToInstitutionRelationService";
import Util from "../util/Util";

export default class SenderModelService {
    private readonly personService: PersonService;
    private readonly institutionService: InstitutionService;
    private readonly relationService: PersonToInstitutionRelationService;

    constructor(personService: PersonService, institutionService: InstitutionService, relationService: PersonToInstitutionRelationService) {
        this.personService = personService;
        this.institutionService = institutionService;
        this.relationService = relationService;
    }

    public getSenderModel = async (personId: number, institutionId: number): Promise<SenderModel> => {
        const person = await this.personService.getPersonModelById(personId);
        const institution = await this.institutionService.getInstitutionModelById(institutionId);
        const relationContacts = Util.firstOrDefault(await this.relationService.getRelationByPersonInstitutionId(personId, institutionId)).Contacts;
        const countOfPersons = await this.relationService.getRelationsCountByPersonId(personId);
        const countOfInstitutions = await this.relationService.getRelationsCountByInstitutionId(institutionId);
        await this.fillContactPersonEmailAddresses(person, institution);
        return new SenderModel(person, institution, relationContacts, countOfPersons, countOfInstitutions);
    };

    public getPersonSenderModelById = async (id: number): Promise<SenderModel> => {
        const personModel = await this.personService.getPersonModelById(id);
        const countOfPersons = await this.relationService.getRelationsCountByPersonId(id);
        await this.fillContactPersonEmailAddresses(personModel, null);
        return new SenderModel(personModel, null, null, countOfPersons, null);
    };

    public getInstitutionSenderModel = async (id: number): Promise<SenderModel> => {
        const institutionModel = await this.institutionService.getInstitutionModelById(id);
        const countOfInstitutions = await this.relationService.getRelationsCountByInstitutionId(id);
        await this.fillContactPersonEmailAddresses(null, institutionModel);
        return new SenderModel(null, institutionModel, null, null, countOfInstitutions);
    };

    private fillContactPersonEmailAddresses = async (person: PersonModel, institution: InstitutionModel): Promise<void> => {
        if (person && person.HasContactPerson) {
            person.ContactPersonEmailAddress = await this.personService.getPreferredEmailAddressByPersonId(person.ContactPersonPersonId);
        }

        if (institution && institution.HasContactPerson) {
            institution.ContactPersonEmailAddress = await this.personService.getPreferredEmailAddressByPersonId(institution.ContactPersonPersonId);
        }
    };
}
